import api from './api';
import { crudOperations } from './api';

class GuaranteeService {
  /**
   * Create a new woodworm guarantee.
   */
  async createGuarantee(franchiseeId, data) {
    try {
      const response = await crudOperations.post(`/guarantees/${franchiseeId}`, data);
      return response.data;
    } catch (error) {
      console.error('Create guarantee error:', error);
      throw error;
    }
  }

  /**
   * Get the next available guarantee number.
   */
  async getNextNumber(franchiseeId) {
    try {
      const response = await crudOperations.get(`/guarantees/${franchiseeId}/next-number`);
      return response.data;
    } catch (error) {
      console.error('Get next guarantee number error:', error);
      throw error;
    }
  }

  /**
   * Get the owning franchisee's name and company details for pre-filling the form.
   */
  async getFranchiseeDetails(franchiseeId) {
    try {
      const response = await crudOperations.get(`/guarantees/${franchiseeId}/franchisee-details`);
      return response.data;
    } catch (error) {
      console.error('Get franchisee details error:', error);
      throw error;
    }
  }

  /**
   * View guarantee PDF in new tab.
   */
  async viewPDF(franchiseeId, guaranteeId) {
    try {
      const response = await api.get(`/guarantees/${franchiseeId}/${guaranteeId}/pdf`, {
        responseType: 'blob'
      });
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      window.open(url, '_blank');
    } catch (error) {
      console.error('View guarantee PDF error:', error);
      throw error;
    }
  }

  /**
   * Download guarantee PDF.
   */
  async downloadPDF(franchiseeId, guaranteeId, { customerName, dateIssued } = {}) {
    try {
      const response = await api.get(`/guarantees/${franchiseeId}/${guaranteeId}/pdf`, {
        responseType: 'blob'
      });
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      const cleanName = (customerName || '').replace(/[^a-zA-Z0-9]/g, '');
      const d = dateIssued ? new Date(dateIssued) : new Date();
      const dateStr = `${String(d.getDate()).padStart(2,'0')}-${String(d.getMonth()+1).padStart(2,'0')}-${d.getFullYear()}`;
      link.download = `Woodworm_Guarantee_${cleanName}_${dateStr}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Download guarantee PDF error:', error);
      throw error;
    }
  }
}

const guaranteeService = new GuaranteeService();
export default guaranteeService;
